import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Steper } from '../../types'
import * as actions from './actions'

export type State = { [id: number]: Steper }

export const initialState: State = {}

export default reducerWithInitialState(initialState).case(
	actions.registerStepers,
	(state, objects) => {
		return { ...state, ..._.keyBy(objects, 'id') }
	},
)
